<script>
  export let addressString
</script>

<a class="block" href="https://maps.google.com/?q={addressString.split(' ').join('+')}">
  {addressString}
</a>